import { create } from "zustand"

export const boxplotVerticalStore = create((set) => ({
  // INFO: 차트에 실제로 쓰이는 상태
  color: "pink",
  boxplotX: ["전체"],
  boxplotSeries: null,
  scatterSeries: null,

  setChart: (id, data, customColors) => {
    const [min, q1, med, q3, max] = data.boxplot
    const color = customColors[data.apt_size] || "pink"

    // INFO: 박스 데이터 (항상 1건만 들어감)
    const boxplotSeries = {
      type: "custom",
      data: [[min, q1, med, q3, max]],
      renderItem: (params, api) => {
        // ! x좌표는 카테고리 index 기준
        const x = api.coord([0, med])[0]

        // ! y좌표는 값 → 화면 좌표
        const yMin = api.coord([0, min])[1]
        const yMax = api.coord([0, max])[1]
        const yQ1 = api.coord([0, q1])[1]
        const yQ3 = api.coord([0, q3])[1]
        const yMed = api.coord([0, med])[1]

        const lineWidth = 150
        const boxWidth = 250

        const boxTop = Math.min(yQ1, yQ3)
        const boxHeight = Math.abs(yQ1 - yQ3)

        return {
          type: "group",
          children: [
            // INFO: 세로 라인
            {
              type: "line",
              shape: {
                x1: x,
                y1: yMin,
                x2: x,
                y2: yMax
              },
              style: { stroke: color, lineWidth: 2 }
            },

            // INFO: box (Q1 ~ Q3)
            {
              type: "rect",
              shape: {
                x: x - boxWidth / 2,
                y: boxTop,
                width: boxWidth,
                height: boxHeight
              },
              style: {
                fill: "#fdfdfd",
                stroke: color,
                lineWidth: 2
              }
            },

            // INFO: 가로라인 최하단
            {
              type: "line",
              shape: {
                x1: x - lineWidth / 2,
                y1: yMin,
                x2: x + lineWidth / 2,
                y2: yMin
              },
              style: { stroke: color, lineWidth: 2 }
            },

            // INFO: 가로라인 중앙
            {
              type: "line",
              shape: {
                x1: x - boxWidth / 2,
                y1: yMed,
                x2: x + boxWidth / 2,
                y2: yMed
              },
              style: { stroke: color, lineWidth: 2 }
            },

            // INFO: 가로라인 최상단
            {
              type: "line",
              shape: {
                x1: x - lineWidth / 2,
                y1: yMax,
                x2: x + lineWidth / 2,
                y2: yMax
              },
              style: { stroke: color, lineWidth: 2 }
            }
          ]
        }
      }
    }

    // 2. 이상치 데이터 (x축 인덱스는 0으로 고정)
    const scatterData = data.outliers.map((o) => [
      0, // x축 위치 (첫 번째 칸)
      o.usage, // y축 값
      o.unit_id, // 툴팁용
      id // 색상 매칭용
    ])

    const scatterSeries = {
      name: "Outlier",
      type: "scatter",
      data: scatterData,
      symbolSize: 10,
      itemStyle: { color: (p) => customColors[p.data[3]] || "pink" }
    }

    set({
      boxplotX: [id],
      boxplotSeries,
      scatterSeries,
      color
    })
  },

  reset: () => {
    set({
      color: "pink",
      boxplotX: ["전체"],
      boxplotSeries: null,
      scatterSeries: null
    })
  }
}))
